import * as z from "zod/v4";

export const setUseOriginalAddress = {
  name: "setUseOriginalAddress" as const,
  input: z.object({
    fulfillmentGroupId: z.string(),
    useOriginalAddress: z.boolean(),
  }),
  output: z.object({ success: z.boolean() }),
};
